<template>
  <div>
    <div>
      <h2 class="mb-5">
        What languages do you speak?
      </h2>
    </div>
    <div v-if="isFetchingUserLanguages">
      <v-skeleton-loader v-for="i in 3" :key="i" type="list-item" />
    </div>
    <div
      v-else
      v-for="language in currentUserLanguages"
      :key="language.id"
      class="d-flex justify-space-between mb-5"
    >
      <div class="languages_summary">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 0 24 24"
          width="24"
        >
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path
            d="M12.65 15.67c.14-.36.05-.77-.23-1.05l-2.09-2.06.03-.03c1.74-1.94 2.98-4.17 3.71-6.53h1.94c.54 0 .99-.45.99-.99v-.02c0-.54-.45-.99-.99-.99H10V3c0-.55-.45-1-1-1s-1 .45-1 1v1H1.99c-.54 0-.99.45-.99.99 0 .55.45.99.99.99h10.18C11.5 7.92 10.44 9.75 9 11.35c-.81-.89-1.49-1.86-2.06-2.88-.16-.29-.45-.47-.78-.47-.69 0-1.13.75-.79 1.35.63 1.13 1.4 2.21 2.3 3.21L3.3 16.87c-.4.39-.4 1.03 0 1.42.39.39 1.02.39 1.42 0L9 14l2.02 2.02c.51.51 1.38.32 1.63-.35zM17.5 10c-.6 0-1.14.37-1.35.94l-3.67 9.8c-.24.61.22 1.26.87 1.26.39 0 .74-.24.88-.61l.89-2.39h4.75l.9 2.39c.14.36.49.61.88.61.65 0 1.11-.65.88-1.26l-3.67-9.8c-.22-.57-.76-.94-1.36-.94zm-1.62 7l1.62-4.33L19.12 17h-3.24z"
          />
        </svg>
        <div class="languages_summary__text__title">
          {{ language.level }} {{ language.name }}
        </div>
      </div>
      <div class="d-flex align-center">
        <EditLanguageAction :language="language" class="mr-2" />
        <div class="text-center " v-if="includes(itemsToRemove, language.id)">
          <v-progress-circular size="30" indeterminate color="primary" />
        </div>
        <div @click="() => onRemove(language.id)" v-else>
          <v-icon>mdi-close</v-icon>
        </div>
      </div>
    </div>
    <AddLanguageAction />
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep">
        Continue
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import EditLanguageAction from "@/views/profile/QuestionsAndAnswers/steps/LanguagesAndSkills/Languages/actions/EditLanguageAction";
import AddLanguageAction from "@/views/profile/QuestionsAndAnswers/steps/LanguagesAndSkills/Languages/actions/AddLanguageAction";
import { LANGUAGES_AND_SKILLS_NAMESPACE } from "@/store/modules/users/languagesAndSkills";
import { createNamespacedHelpers } from "vuex";
import {
  FETCH_USER_LANGUAGES,
  REMOVE_USER_LANGUAGE
} from "@/store/modules/users/languagesAndSkills/actions";
import { copyState } from "@/utils/helpers";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { filter, includes } from "lodash";

const {
  mapActions,
  mapState: mapLanguagesAndSkillsState
} = createNamespacedHelpers(LANGUAGES_AND_SKILLS_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "Language",
  components: {
    PrimaryButton,
    EditLanguageAction,
    AddLanguageAction
  },
  created() {
    this.fetchUserLanguages(this.self.id);
  },
  data() {
    return {
      isLoading: false,
      itemsToRemove: [],
      showValidationErrors: false
    };
  },
  computed: {
    ...mapAuthState({
      self: state => state.userData
    }),
    ...mapLanguagesAndSkillsState(
      copyState(["isFetchingUserLanguages", "currentUserLanguages"])
    )
  },
  methods: {
    ...mapActions({
      removeLanguage: REMOVE_USER_LANGUAGE,
      fetchUserLanguages: FETCH_USER_LANGUAGES
    }),
    async onRemove(idToRemove) {
      this.itemsToRemove = [...this.itemsToRemove, idToRemove];
      await this.removeLanguage({
        languageId: idToRemove,
        userId: this.self.id
      });
      this.itemsToRemove = filter(this.itemsToRemove, idToRemove);
    },
    nextStep() {
      this.$emit("nextStep");
    },
    includes
  }
};
</script>

<style lang="scss">
.languages_summary {
  width: 100%;
  padding-top: 5px;

  svg {
    float: left;
    margin-top: 0px;
    margin-right: 10px;
  }

  &__text {
    float: left;

    &__title {
      font-weight: bold;
    }

    &__subtitle {
      color: $secondary-text;
    }
  }
}
</style>
